import { Text } from '@adobe/react-spectrum';
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import React from 'react';

const SpectrumTextRenderer = ({ uischema }: RendererProps) => {
  const text = uischema;

  return (
    <Text
      UNSAFE_style={...text?.options?.style}
      {...text?.options?.spectrumProps}
    >
      {text?.options?.value}
    </Text>
  );
};

export const spectrumTextRendererTester: RankedTester = rankWith(
  3,
  uiTypeIs('Text')
);

export default withJsonFormsLayoutProps(SpectrumTextRenderer);
